<div
  class="selections-menu-trigger"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  #triggerEl
  (mouseenter)="onHoverEnter()"
  (mouseleave)="onHoverLeave()"
>
  <ng-content />
</div>

@if (mode() === 'inline' && effectiveOpen()) {
  <div
    class="selections-menu selections-menu--inline"
    [style.top]="inlineStyle()['top']"
    [style.bottom]="inlineStyle()['bottom']"
    [style.right]="inlineStyle()['right']"
    (mouseenter)="onHoverEnter()"
    (mouseleave)="onHoverLeave()"
  >
    <ng-container *ngTemplateOutlet="menuContent" />
  </div>
}

@if (mode() === 'overlay') {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="effectiveOpen()"
    [cdkConnectedOverlayPositions]="menuPositions"
    [cdkConnectedOverlayHasBackdrop]="false"
    cdkConnectedOverlayPanelClass="selections-menu-overlay"
  >
    <div class="selections-menu" (mouseenter)="onHoverEnter()" (mouseleave)="onHoverLeave()">
      <ng-container *ngTemplateOutlet="menuContent" />
    </div>
  </ng-template>
}

<ng-template #menuContent>
  <button type="button" class="selections-menu-header" (click)="onCreate($event)">
    <span>Add to selection</span>
    <outlaw-icon class="selections-menu-add" name="plusInCircle" />
  </button>

  <div class="selections-menu-list">
    @if (selections().length === 0) {
      <div class="selections-menu-empty">No selections yet</div>
    }

    @for (selection of selections(); track selection.id) {
      <button
        type="button"
        class="selections-menu-item"
        [class.is-active]="isPostInSelection(selection)"
        (click)="onToggle($event, selection)"
      >
        <span class="selections-menu-name" [title]="selection.name">{{ selection.name }}</span>
        <outlaw-count-badge [count]="selection.posts_uuids.length" />
      </button>
    }
  </div>
</ng-template>
